import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import FormRadio from "Root/profile/components/common/FormRadio";
import H4Font from "Root/profile/components/common/H4Font";
import SmallFont from "Root/profile/components/common/SmallFont";
import { useRef } from "react";
import CheckoutReviewBox from "../CheckoutReviewBox";
import cx from "classnames";
import styles from "./styles.module.scss";
import Checkmark from "Images/shop/checkmark.svg";
import { useDispatch, useSelector } from "react-redux";
import { setIsEditPlanSelect, setEditPaymentMethod, setEditShippingAddress, setEditShippingMethod, } from "Root/checkout/redux/slices/checkoutComponentSlice";
import { fetchPricing, setPlan } from "Root/checkout/redux/slices/checkoutPricingSlice";
import Button from "Root/profile/components/common/Button";
import useCheckoutOrderSummary from "../CheckoutOrderSummary/useCheckoutOrderSummary";
const PlanSelect = () => {
    const dispatch = useDispatch();
    const ref = useRef(null);
    const plan = useSelector((state) => state.checkoutPricing.plan);
    const componentState = useSelector((state) => state.checkoutComponent);
    const { calculateTotalPriceWithoutBottle } = useCheckoutOrderSummary();
    const bullets = [
        "Includes a personalized 7-day meal plan",
        "Access to our team of Registered Dietitians",
        `Ships every 4 weeks. Delay or cancel anytime`,
    ];
    const { otb, subscription } = useSelector((state) => state.checkoutPricing);
    const { discount, subtotal } = subscription;
    const calculate15PercentMoreWithoutFees = otb.subtotal;
    const calculateDiscountPercentage = (discount / subtotal) * 100;
    const onChangePlan = async (value) => {
        dispatch(setPlan(value));
        await dispatch(fetchPricing("standard"));
        // if (value === "otb" && discount) {
        //   toastService.errorMessage("Discounts apply to subscription purchases only");
        // }
    };
    const goToShippingInfo = () => {
        document.getElementById("shipping-address")?.scrollIntoView({ block: "nearest", behavior: "smooth" });
        dispatch(setIsEditPlanSelect(false));
        dispatch(setEditPaymentMethod(false));
        dispatch(setEditShippingAddress(true));
        dispatch(setEditShippingMethod(false));
    };
    const getPropsForReviewBox = () => {
        return {
            onEdit: () => {
                dispatch(setIsEditPlanSelect(true));
                dispatch(setEditPaymentMethod(false));
                dispatch(setEditShippingAddress(false));
                dispatch(setEditShippingMethod(false));
                if (ref.current) {
                    window.scrollTo(0, ref.current.offsetTop);
                }
            },
            data: [
                {
                    title: "Plan Type",
                    text: [
                        plan === "otb" ? "One Time Purchase" : "Subscribe & Save",
                        plan === "otb" ? "" : `Delivered every ${subscription.delivery_frequency}`,
                    ],
                },
            ],
        };
    };
    return (_jsx("div", { ref: ref, className: styles.wrapper, children: componentState.isEditPlanSelect ? (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx(H4Font, { fontWeight: 400, children: "Select Your Plan" }), _jsx(SmallFont, { children: "Shipping fees and taxes calculated at next step." })] }), _jsx("div", { className: styles.subscription, children: _jsxs("div", { onClick: (e) => {
                            e.stopPropagation();
                            onChangePlan("subscription");
                        }, className: cx(styles.select_item, plan !== "otb" && styles.is_selected), children: [_jsxs("div", { className: styles.first_row, children: [_jsx(FormRadio, { name: "plan", id: "subscription", value: "subscription", onChange: () => { }, checked: plan === "subscription", label: "Subscribe & Save", extraClassName: styles.radio, boldLabel: true }), _jsx("div", { className: styles.prices, children: _jsx("div", { className: styles.discountBadge, children: "15% off every order" }) })] }), _jsx("div", { className: styles.bullets, children: bullets.map((item) => (_jsxs("div", { className: styles.bullet, children: [_jsx("img", { src: Checkmark, alt: "checkmark", className: styles.checkmark }), _jsx(SmallFont, { className: styles.checkmarkText, children: item })] }, item))) })] }) }), _jsx("div", { onClick: (e) => {
                        e?.stopPropagation();
                        onChangePlan("otb");
                    }, className: cx(styles.select_item, styles.otb, plan === "otb" && styles.is_selected), children: _jsx("div", { className: styles.first_row, children: _jsx(FormRadio, { name: "plan", id: "otb", value: "otb", onChange: () => { }, checked: plan === "otb", label: "One Time Purchase", extraClassName: styles.radio, boldLabel: true }) }) }), _jsx("div", { className: styles.button, children: componentState.isEditPlanSelect && (_jsx(Button, { onClick: goToShippingInfo, color: "court", children: "continue to shipping" })) })] })) : (_jsx(CheckoutReviewBox, { ...getPropsForReviewBox() })) }));
};
export default PlanSelect;
